import { Dispatch } from "redux";
import { TenantContextAction, UsersMap } from "../types/tenant-context.types";
import * as JournalApi from "api/journal.api";
import { updateUsersList } from "./tenant-context.actions";
import {
  JournalEntry,
  JournalEntryContainer,
  JournalType,
} from "model/journal.model";
import {
  JournalAction,
  RESET_JOURNAL,
  UPDATE_LIST_JOURNAL,
} from "../types/journal.types";
import { PaginatedSearchJournalRequest } from "model/paginated-journal-request.model";

/** ---- ACTIONS ---- */
export const refreshJournalEntries = (
  userId: number,
  patientId: number,
  request: PaginatedSearchJournalRequest,
  userMap: UsersMap
) => async (dispatch: Dispatch<JournalAction | TenantContextAction>) => {
  const journal = await JournalApi.findAllJournalEntries(
    userId,
    patientId,
    request
  );
  const userIds = new Set<number>();
  journal.journalEntryContainers.forEach((container: JournalEntryContainer) =>
    userIds.add(container.authorId)
  );
  Object.values(journal.journalEntries)
    .flat()
    .forEach((journalEntry: JournalEntry) =>
      userIds.add(journalEntry.authorId)
    );

  updateListJournalEntries(journal)(dispatch);
  updateUsersList(Array.from<number>(userIds), userMap)(dispatch);
  return Promise.resolve(journal.processedIds);
};

/** ---- DISPATCHERS ---- */
export const updateListJournalEntries = (journal: JournalType) => {
  return (dispatch: Dispatch<JournalAction>) => {
    dispatch({
      type: UPDATE_LIST_JOURNAL,
      payload: journal,
    });
  };
};

export const resetJournal = () => {
  return (dispatch: Dispatch<JournalAction>) => {
    dispatch({ type: RESET_JOURNAL });
  };
};
